
import React, { useState } from 'react'
import Layout from "../../components/Layout/Layout";
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid'
import { DocumentDownloadIcon, DotsHorizontalIcon } from '@heroicons/react/outline'
import DepositServices from '../../services/DepositServices';
import { useEffect } from 'react';
import Paginate from './../../utils/Paginate';
import DatePicker from 'react-date-picker';
import { convert, formatDate } from './../../utils/convertDate';


const statusStyles = {
    Successful: 'bg-green-500 text-white',
    Pending: 'bg-amber-400 text-white',
    Failed: 'bg-orange-600 text-white',
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
export default function Deposits() {
    const [deposit, setDeposit] = useState([]);
    const [search, setSearch] = useState("");
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [status, SetStatus] = useState("");
    const [pageLength, setPageLength] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));

    const listDeposits = async () => {
        const Deposit = await DepositServices.listDeposits(pageIndex, 10, search, fromm, too, status);
        if (Deposit) {
            setDeposit([...Deposit.data.result]);
            setPageLength([...Deposit.data.result].length);
            setPageNumber(Deposit.data.totalCount)
            setPageIndex(Deposit.data.pageIndex)
            setPrev(Deposit.data.hasPreviousPage);
            setPage(Deposit.data.totalPages)
            setNextPage(Deposit.data.hasNextPage)
        }
    }
    const handleStatus = async (text) => {
        if (text === "All") {
            const Deposit = await DepositServices.listDeposits(pageIndex, 10, search, fromm, too, status);
            if (Deposit) {
                setDeposit([...Deposit.data.result]);
                setPageLength([...Deposit.data.result].length);
                setPageNumber(Deposit.data.totalCount)
                setPageIndex(Deposit.data.pageIndex)
                setPrev(Deposit.data.hasPreviousPage);
                setPage(Deposit.data.totalPages)
                setNextPage(Deposit.data.hasNextPage)
            }
        } else {
            SetStatus(text);
            const Deposit = await DepositServices.listDeposits(pageIndex, 10, search, fromm, too, text);
            if (Deposit) {
                setDeposit([...Deposit.data.result]);
                setPageLength([...Deposit.data.result].length);
                setPageNumber(Deposit.data.totalCount)
                setPageIndex(Deposit.data.pageIndex)
                setPrev(Deposit.data.hasPreviousPage);
                setPage(Deposit.data.totalPages)
                setNextPage(Deposit.data.hasNextPage)
            }
        }

    }

    const range = async (e) => {
        e.preventDefault();
        const newDate = formatDate(formValues.from)
        setFrom(formValues.from)
        var longDate = formatDate(newDate);
        setFromm(convert(longDate));

        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        setToo(convert(toDate));

        const Deposit = await DepositServices.listDeposits(pageIndex, 10, search, convert(newDate), convert(toDate), status);
        if (Deposit) {
            setDeposit([...Deposit.data.result]);
            setPageLength([...Deposit.data.result].length);
            setPageNumber(Deposit.data.totalCount);
            setPageIndex(Deposit.data.pageIndex);
            setPrev(Deposit.data.hasPreviousPage);
            setPage(Deposit.data.totalPages)
            setNextPage(Deposit.data.hasNextPage)
        }
    }
    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
    };
    const exportCSV = async () => {
        const resp = await DepositServices.exportDeposit(search, fromm, too, status);
        window.open(resp.data);
    }
    const searchDeposit = async (text) => {
              setSearch(text);
    }
    useEffect(() => {
        listDeposits();
    }, [pageIndex])
    return (<>
        <Layout title={'Deposits'} current={'/deposits'} pageTag={'deposit'}>
            <React.Fragment>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                    <div className="mt-4 sm:mt-0 sm:ml-16 flex justify-end">
                        <button
                            type="button"
                            onClick={exportCSV}
                            className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                            <DocumentDownloadIcon className="w-4 mr-1.5" />
                            Export CSV
                        </button>
                    </div>
                    <div className="sm:flex sm:items-center mt-10">
                        <div className="sm:flex-auto flex">
                         
                            <div className="relative rounded-md shadow-sm ml-3">
                                <p className='text-sm leading-3 text-gray-500'>From</p>
                                <div>
                                    <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                </div>
                            </div>
                            <div className=" relative rounded-md shadow-sm ml-3">
                                <p className='text-sm leading-3 text-gray-500'>To</p>
                                <div>
                                    <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                </div>
                            </div>
                            <div className='flex ml-3'>
                                <div className="mt-5 relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        name="user"
                                        id="user"
                                        onChange={(e) => searchDeposit(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search deposits"
                                    />
                                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                        <div className='tooltip'>
                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                            <span className="tooltiptext"> <p>Search by email address, surname and first name</p></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                              <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                <select
                                    id="currency"
                                    name="currency"
                                    onChange={(e) => handleStatus(e.target.value)}
                                    placeholder="Filter by"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                >
                                    <option value={"All"}>Sort by</option>
                                    <option value={"All"}>All</option>
                                    <option value={"Pending"}>Pending</option>
                                    <option value={"Success"}>Successful</option>
                                    <option value={"Failed"}>Failed</option>
                                </select>
                            </div>
                            <div className='mt-5 ml-4'>
                                <button
                                    onClick={range}
                                    className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                            </div>
                          
                        </div>

                    </div>
                    {deposit.length === 0 ? (
                        <div className="mt-8"> No data available for these dates to show. </div>
                    ) : 
                    <>
                    <div className="mt-4 flex flex-col">
                        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">

                                <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                    <table className="min-w-full table-fixed divide-y divide-gray-300">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-400">
                                                    Sender's Name
                                                </th>
                                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400 ">
                                                    Account Officer
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Branch
                                                </th>
                                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Tranaction Date
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Channel for Depositing
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Beneficiary’s  Account Number
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Beneficiary’s  Name
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Paying Bank
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Amount
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Card Number
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Remarks
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Reference Number
                                                </th>

                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Status
                                                </th>

                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">

                                                </th>

                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    <span className="sr-only">Edit</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {deposit.map((person, i) => (
                                                <tr key={i} className="bg-gray-50">
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.senderName}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountOfficer}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.branch}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.transDate}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.chaneelDeposit}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.beneficiaryName}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.benefiaryAcctNo}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.amount}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.payingBank}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.cardNumber}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.remarks}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.reference}</td>
                                                    <td><span className={classNames(
                                                        statusStyles[person.status], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.status}</span></td>
                                                    <td><DotsHorizontalIcon className='text-gray-500' /></td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                </>
                    }
               

                </div>

            </React.Fragment>
        </Layout></>)
}